/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

export const DONE_LOADING_SITEMAP_COUNTS = '@@nzr/sitemap/DONE_LOADING_SITEMAP_COUNTS'
export const DONE_LOADING_SITEMAP_URLS = '@@nzr/sitemap/DONE_LOADING_SITEMAP_URLS'
export const RECEIVE_SITEMAP_COUNTS = '@@nzr/sitemap/RECEIVE_SITEMAP_COUNTS'
export const RECEIVE_SITEMAP_URLS = '@@nzr/sitemap/RECEIVE_SITEMAP_URLS'
export const START_LOADING_SITEMAP_COUNTS = '@@nzr/sitemap/START_LOADING_SITEMAP_COUNTS'
export const START_LOADING_SITEMAP_URLS = '@@nzr/sitemap/START_LOADING_SITEMAP_URLS'

export const SITEMAP_URLS_PER_PAGE = 50
export const PRODUCT_URLS_PER_PAGE = 150
